import { takeLeading, put, take } from 'redux-saga/effects';
import { SERVICE_RELOAD } from '../../constants/service';
import { destroyApp, renderApp } from '../../actions/app/initialization';
import { DESTROY_APP_SUCCESS } from '../../constants/initialization';

export function* serviceReloadWorker() {
  yield put(destroyApp());
  yield take(DESTROY_APP_SUCCESS);
  yield put(renderApp());
}

export function* serviceReloadWatcher() {
  yield takeLeading(SERVICE_RELOAD, serviceReloadWorker);
}
